import { createActions } from 'redux-actions';

export default createActions(
  {
    LOGIN: (id, role, menus, key, tmsUserRid) => ({ id, role, menus, key, tmsUserRid }),
    LOGOUT: () => ({}),
  },
  { prefix: 'AUTH' }
);
